/* ==========================================================================
   I&C redesign: header, search, The Edit, collections, reveal, scent quiz.
   Works with the store's real products (Shopify's search and collection data).
   ========================================================================== */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const money = (n) => "$" + Number(n).toFixed(2);
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const sized = (url, w) => {
    if (!url) return "";
    try { const u = new URL(url, location.origin); u.searchParams.set("width", w); return u.toString(); } catch (e) { return url; }
  };

  /* House and name from a title: "Creed Centaurus EDP 100 ml" -> ["Creed", "Centaurus EDP 100 ml"] */
  let HOUSES = [];
  try { HOUSES = JSON.parse(($("#rd-brands") || {}).textContent || "[]"); } catch (e) {}
  const split = (title) => {
    const t = String(title || "").trim(), tl = t.toLowerCase();
    const h = HOUSES.find((b) => tl.startsWith(b.toLowerCase() + " "));
    return h ? [t.slice(0, h.length), t.slice(h.length + 1).trim()] : ["", t];
  };
  window.rdSplitTitle = split;

  /* ---------- Header: transparent over the hero, solid once scrolled ---------- */
  const header = $("[data-rd-header]");
  const hero = $(".rd .hero");
  const setSolid = () => {
    if (!header) return;
    const limit = hero ? hero.offsetHeight - 120 : 0;
    header.classList.toggle("is-solid", !hero || window.scrollY > Math.min(40, limit));
  };
  setSolid();
  window.addEventListener("scroll", setSolid, { passive: true });

  /* ---------- Collections panel ---------- */
  const megaBtn = $("[data-mega]");
  const mega = $(".rd .mega");
  let closeTimer;
  const openMega = (open) => {
    if (!header) return;
    clearTimeout(closeTimer);
    header.classList.toggle("is-open", open);
    megaBtn && megaBtn.setAttribute("aria-expanded", String(open));
  };
  if (megaBtn && mega) {
    [megaBtn, mega].forEach((el) => {
      el.addEventListener("mouseenter", () => openMega(true));
      el.addEventListener("mouseleave", () => { closeTimer = setTimeout(() => openMega(false), 220); });
    });
    megaBtn.addEventListener("click", () => openMega(megaBtn.getAttribute("aria-expanded") !== "true"));
    mega.addEventListener("focusout", (e) => { if (!header.contains(e.relatedTarget)) openMega(false); });
  }

  /* ---------- Phone menu ---------- */
  const drawer = $(".rd .drawer");
  const toggle = $(".rd .menu-toggle");
  if (toggle && drawer) {
    toggle.addEventListener("click", () => {
      const open = !drawer.classList.contains("is-open");
      drawer.classList.toggle("is-open", open);
      header.classList.toggle("is-solid", open || !hero || window.scrollY > 40);
      toggle.setAttribute("aria-expanded", String(open));
      toggle.textContent = open ? "Close" : "Menu";
      document.body.style.overflow = open ? "hidden" : "";
    });
  }

  /* ---------- Search: Shopify's predictive search, as you type ---------- */
  const search = $("[data-rd-search]");
  if (search) {
    const input = $("input[name=q]", search);
    const list = $(".search__results", search);
    const hint = $(".search__hint", search);
    const popular = $("[data-popular]", search);
    const all = $("[data-search-all]", search);
    const bar = $("[data-search-bar]");
    const base = (window.routes && window.routes.predictive_search_url) || "/search/suggest";
    let timer, ctrl;
    const show = (items, q) => {
      hint.hidden = items.length > 0;
      hint.textContent = items.length ? "" : `Nothing matches “${q}”. Try a house or a name: Creed, Lattafa, Sauvage.`;
      list.innerHTML = items.map((p) => {
        const [house, name] = split(p.title);
        const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        return `<li><a href="${esc(p.url)}">
          <span class="search__thumb">${img ? `<img src="${esc(sized(img, 120))}" alt="" loading="lazy">` : ""}</span>
          <span class="search__text"><span class="b">${esc(house)}</span><span class="n">${esc(name)}</span></span>
          <span class="p">${p.available === false ? "Sold out" : money(p.price)}</span>
        </a></li>`;
      }).join("");
      all.hidden = !q;
      all.href = `/search?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last`;
    };
    const find = () => {
      const q = input.value.trim();
      popular.hidden = !!q;
      clearTimeout(timer);
      if (!q) { list.innerHTML = ""; hint.hidden = false; hint.textContent = "Search by house or name: Creed, Lattafa, Sauvage."; all.hidden = true; return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = "AbortController" in window ? new AbortController() : null;
        try {
          const url = `${base}.json?q=${encodeURIComponent(q)}&resources%5Btype%5D=product&resources%5Blimit%5D=8&resources%5Boptions%5D%5Bunavailable_products%5D=last`;
          const res = await fetch(url, ctrl ? { signal: ctrl.signal } : {});
          const data = await res.json();
          show(((data.resources || {}).results || {}).products || [], q);
        } catch (e) { if (e.name !== "AbortError") show([], q); }
      }, 180);
    };
    const open = (on, q) => {
      if (on && drawer && drawer.classList.contains("is-open")) toggle.click();
      search.classList.toggle("is-open", on);
      search.setAttribute("aria-hidden", String(!on));
      document.body.style.overflow = on ? "hidden" : "";
      if (on) {
        if (q != null) input.value = q;
        find();
        input.focus();                                       // the panel is visible at once, so typing carries on here
        setTimeout(() => { if (document.activeElement !== input) input.focus(); }, 60);
      } else if (bar) bar.value = "";
    };
    $$("[data-search]").forEach((b) => b.addEventListener("click", () => open(true)));
    if (bar) {
      bar.addEventListener("focus", () => open(true, bar.value));
      bar.addEventListener("input", () => { input.value = bar.value; find(); input.focus(); });   // letters typed before the switch
    }
    popular.addEventListener("click", (e) => {
      const b = e.target.closest("[data-q]");
      if (b) { input.value = b.dataset.q; find(); input.focus(); }
    });
    $(".search__close", search).addEventListener("click", () => open(false));
    input.addEventListener("input", find);
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      if (search.classList.contains("is-open")) open(false);
      openMega(false);
    });
  }

  /* ---------- The Edit: tabs swap between product grids ---------- */
  $$("[data-edit]").forEach((edit) => {
    const tabs = $$("[data-edit-tab]", edit);
    const panels = $$("[data-edit-panel]", edit);
    tabs.forEach((b) => b.addEventListener("click", () => {
      const i = tabs.indexOf(b);
      tabs.forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
      const current = panels.find((p) => !p.hidden);
      if (current === panels[i]) return;
      current.classList.add("is-swapping");
      setTimeout(() => {
        panels.forEach((p, j) => { p.hidden = j !== i; p.classList.remove("is-swapping"); });
      }, 420);
    }));
  });

  /* ---------- Collections: a floating plate follows the hovered row ---------- */
  const coll = $(".rd .collections");
  if (coll && window.matchMedia("(hover: hover) and (min-width: 1101px)").matches) {
    const plate = $(".collections__plate", coll);
    const rows = $(".collections__list", coll);
    if (plate && rows) {
      $$("a[data-img]", rows).forEach((a, i) => {
        a.addEventListener("mouseenter", () => {
          plate.style.setProperty("--y", `${a.offsetTop + a.offsetHeight / 2 - plate.offsetHeight / 2}px`);
          plate.classList.add("is-on");
          $$("img", plate).forEach((im, j) => im.classList.toggle("is-on", j === i));
        });
      });
      rows.addEventListener("mouseleave", () => plate.classList.remove("is-on"));
    }
  }

  /* ---------- Slow reveal on scroll ---------- */
  const io = "IntersectionObserver" in window && new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
  }, { rootMargin: "0px 0px -8% 0px" });
  $$(".rd .reveal").forEach((el) => (io ? io.observe(el) : el.classList.add("is-in")));

  /* ==========================================================================
     Product page: photos, options, and the other strengths and sizes of the same perfume
     ========================================================================== */
  const pdp = $("[data-rd-pdp]");
  if (pdp) {
    // Back: return to where they came from when it was this store
    const backLink = $("[data-pdp-back]", pdp);
    if (backLink && document.referrer.startsWith(location.origin) && history.length > 1) {
      backLink.addEventListener("click", (e) => { e.preventDefault(); history.back(); });
    }

    // Photos
    const main = $("[data-pdp-main] img", pdp);
    $$(".pdp__thumb", pdp).forEach((b) => b.addEventListener("click", () => {
      if (!main) return;
      main.removeAttribute("srcset");
      main.src = b.dataset.src;
      main.srcset = b.dataset.srcset;
      main.classList.toggle("is-raw", b.dataset.raw === "true");
      main.classList.toggle("is-cut", b.dataset.raw !== "true");
      $$(".pdp__thumb", pdp).forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
    }));

    // Variants within one listing (when a product has several)
    const chipsBox = $("[data-variant-chips]", pdp);
    if (chipsBox) {
      const idInput = $("form[data-type='add-to-cart-form'] [name=id]", pdp);
      const submit = $(".product-form__submit", pdp);
      const priceEl = $("[data-pdp-price]", pdp);
      const label = $("[data-variant-label]", pdp);
      chipsBox.addEventListener("click", (e) => {
        const b = e.target.closest("[data-variant]");
        if (!b) return;
        $$("[data-variant]", chipsBox).forEach((x) => x.setAttribute("aria-checked", String(x === b)));
        const ok = b.dataset.available === "true";
        idInput.value = b.dataset.variant;
        submit.disabled = !ok;
        $("span", submit).textContent = ok ? "Add to bag" : "Sold out";
        priceEl.classList.toggle("is-sold", !ok);
        priceEl.innerHTML = `${b.dataset.compare ? `<s>${b.dataset.compare}</s> ` : ""}${b.dataset.price}${ok ? "" : "<span>Sold out</span>"}`;
        if (label) label.textContent = b.dataset.title;
        const url = new URL(location.href); url.searchParams.set("variant", b.dataset.variant);
        history.replaceState(null, "", url);
        const pick = $("pickup-availability", pdp);
        if (pick && pick.fetchAvailability) pick.fetchAvailability(b.dataset.variant);
      });
    }

    // Other strengths and sizes: separate listings in the store, linked here as choices
    const box = $("[data-rd-lines]", pdp);
    const handle = pdp.dataset.handle;
    const OZ = { 200: "6.7", 150: "5.0", 125: "4.2", 120: "4.0", 100: "3.4", 90: "3.0", 85: "2.9", 80: "2.7", 75: "2.5", 70: "2.4", 60: "2.0",
      50: "1.7", 40: "1.35", 35: "1.2", 30: "1.0", 25: "0.8", 20: "0.67", 15: "0.5", 10: "0.33", 7.5: "0.25", 7: "0.24", 6: "0.2", 5: "0.17", 4.5: "0.15", 3.5: "0.12" };
    const oz = (ml) => OZ[ml] || (ml / 29.5735).toFixed(1);
    if (box && box.dataset.src) {
      fetch(box.dataset.src).then((r) => r.json()).then(async (data) => {
        const line = (data.lines || []).find((l) => l.some((e) => e[0] === handle));
        if (!line) return;
        const live = await Promise.all(line.map((e) => fetch(`/products/${e[0]}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)));
        const items = line.map((e, i) => ({ handle: e[0], v: e[1], label: e[2], ml: e[3], mini: !!e[4], p: live[i] })).filter((x) => x.p);
        const cur = items.find((x) => x.handle === handle);
        if (!cur || items.length < 2) return;
        const inStock = (x) => x.p.available;
        const versions = [...new Map(items.map((x) => [x.v, x.label])).entries()];
        const bestFor = (v) => {
          const vs = items.filter((x) => x.v === v);
          return vs.find((x) => x === cur) || vs.find((x) => x.ml === cur.ml && inStock(x)) || vs.find((x) => x.ml === cur.ml)
            || vs.find((x) => inStock(x) && !x.mini) || vs.find(inStock) || vs[0];
        };
        const sizes = [];
        items.filter((x) => x.v === cur.v).forEach((x) => {
          const i = sizes.findIndex((y) => y.ml === x.ml);
          if (i < 0) sizes.push(x);
          else if (x === cur || (sizes[i] !== cur && !inStock(sizes[i]) && inStock(x))) sizes[i] = x;
        });
        sizes.sort((a, b) => a.ml - b.ml);
        let html = "";
        if (versions.length > 1) {
          html += `<div class="opt"><p class="opt__label">Strength <span>${esc(cur.label)}</span></p><div class="opt__chips">` +
            versions.map(([v, label]) => {
              const to = bestFor(v), here = v === cur.v;
              const sold = !items.some((x) => x.v === v && inStock(x));
              return `<a class="chip${sold ? " is-sold" : ""}" href="/products/${to.handle}"${here ? ' aria-current="true"' : ""}${sold ? ` aria-label="${esc(label)}, sold out"` : ""}>${esc(label)}</a>`;
            }).join("") + `</div></div>`;
        }
        if (sizes.length > 1) {
          html += `<div class="opt"><p class="opt__label">Size <span>${cur.ml} ml${cur.mini ? " · Mini" : ""}</span></p><div class="opt__chips">` +
            sizes.map((x) => `<a class="chip chip--size${inStock(x) ? "" : " is-sold"}" href="/products/${x.handle}"${x === cur ? ' aria-current="true"' : ""}>
              <span>${x.ml} ml</span><small>${inStock(x) ? (x.mini ? "Mini" : oz(x.ml) + " oz") : "Sold out"}</small></a>`).join("") + `</div></div>`;
        }
        if (html) { box.innerHTML = html; box.hidden = false; }
      }).catch(() => {});
    }
  }

  /* ==========================================================================
     Scent quiz: six questions, scored against real products from the store
     ========================================================================== */
  const quizHome = $("[data-rd-quiz]");
  if (!quizHome) return;                       // other pages: quiz links lead to the homepage quiz

  const STYLES = {
    fresh:  ["aquatic", "citrus", "fresh", "aromatic", "marine", "sea", "salt", "lemon", "bergamot", "mandarin", "orange", "tangerine", "grapefruit", "neroli", "lavender", "sage", "juniper", "mint", "green", "ozonic", "water"],
    floral: ["floral", "rose", "jasmine", "iris", "tuberose", "peony", "orangeblossom", "gardenia", "violet", "lily", "magnolia", "freesia", "ylang", "flower", "geranium", "lotus"],
    fruity: ["fruity", "strawberry", "raspberry", "blackcurrant", "cassis", "pear", "plum", "peach", "apple", "pineapple", "apricot", "fig", "cherry", "berry", "berries", "lychee", "melon", "watermelon", "coconut"],
    sweet:  ["gourmand", "vanilla", "tonka", "toffee", "caramel", "cacao", "chocolate", "coffee", "almond", "honey", "praline", "sugar", "sweet", "candy", "marshmallow"],
    warm:   ["amber", "musk", "ambrette", "benzoin", "labdanum", "resin*", "warm"],
    woody:  ["woody", "wood", "sandalwood", "cedar*", "vetiver", "patchouli", "oakmoss", "moss", "guaiac", "cypress", "pine", "chypre"],
    smoky:  ["leather", "oud", "agarwood", "incense", "tobacco", "birch", "saffron", "smoke", "smoky"],
    spicy:  ["spic*", "cardamom", "pepper", "cinnamon", "clove", "nutmeg", "ginger", "coriander"],
  };
  const KEYS = Object.keys(STYLES);
  // Whole words only (plus plural/-y forms), so "cloud" is not oud and "pineapple" is not pine; "word*" matches as a prefix.
  const WORD_RE = Object.fromEntries(KEYS.map((k) => [k, STYLES[k].map((w) =>
    new RegExp(w.endsWith("*") ? `\\b${w.slice(0, -1)}` : `\\b${w}(?:s|es|y)?\\b`))]));
  const NAMES = { fresh: "Fresh", floral: "Floral", fruity: "Fruity", sweet: "Gourmand", warm: "Amber", woody: "Woody", smoky: "Smoky", spicy: "Spicy" };
  const PROFILE_LINE = {
    fresh: "Clean, bright and easy to wear: the scent people notice as you walk past.",
    floral: "Soft, romantic and polished: the one people remember you by.",
    fruity: "Juicy and playful with a sweet lift: easy to love, hard to forget.",
    sweet: "Warm, cosy and a little addictive: the kind of scent people lean in for.",
    warm: "Smooth amber and musk that melts into your skin and stays there.",
    woody: "Grounded and refined: dry woods and quiet confidence.",
    smoky: "Dark, rich and magnetic: leather, oud and smoke that turn heads.",
    spicy: "Bold and warm with a spark: the kind of spice people ask about.",
  };
  const SKIP = /\b(set|sets|gift|mini|minis|lotion|deodorant|deo|shower|gel|body|travel|sample|vial|tester|candle|cream|balm|soap|kit|pack|duo|trio|coffret)\b/;

  const notesFrom = (text) => {
    const out = [];
    const re = /(top|heart|middle|base|key) notes?:\s*([^\n.;]+)/g;
    let m;
    while ((m = re.exec(text))) out.push(...m[2].split(/,| and /).map((s) => s.trim()).filter(Boolean));
    return out.slice(0, 9);
  };
  const profileOf = (text) => {
    const v = Object.fromEntries(KEYS.map((k) => [k, 0]));
    const t = text.replace(/orange blossom/g, "orangeblossom");
    const fam = (t.match(/fragrance family:\s*([^\n.;]+)/) || [])[1] || "";
    KEYS.forEach((k) => {
      WORD_RE[k].forEach((re) => { if (re.test(t)) v[k] += 1; });
      if (WORD_RE[k].some((re) => re.test(fam))) v[k] += 3;             // the stated family counts most
    });
    const total = KEYS.reduce((s, k) => s + v[k], 0) || 1;
    KEYS.forEach((k) => (v[k] /= total));
    v.sure = Math.min(1, total / 8);                 // how much the description says: a one-line blurb is a weak match
    return v;
  };
  const strengthOf = (title) => {
    const t = title.toLowerCase();
    if (/eau de parfum|\bedp\b/.test(t)) return /intense|absolu|elixir|extreme/.test(t) ? 1 : 0;
    if (/toilette|\bedt\b|cologne|\bedc\b|mist/.test(t)) return -1;
    if (/parfum|extrait|elixir|essence|concentr/.test(t)) return 1;
    return 0;
  };

  let CATALOG = null, loading = null;
  const MAX_PAGES = 12;                              // 250 products a page: covers collections of up to 3,000
  const loadCatalog = () => (CATALOG ? Promise.resolve(CATALOG) : (loading = loading || (async () => {
    const sources = JSON.parse(quizHome.dataset.sources || "[]");
    const byUrl = new Map();
    const add = (items, gender) => items.forEach((p) => {
      if (SKIP.test(p.t.toLowerCase())) return;
      const seen = byUrl.get(p.u);
      if (seen) { if (seen.gender !== gender) seen.gender = "shared"; return; }
      const text = `${p.t} ${p.x} ${p.g}`.toLowerCase();
      byUrl.set(p.u, { ...p, gender, text, profile: profileOf(text), strength: strengthOf(p.t), notes: notesFrom(p.x || "") });
    });
    // every page of each collection (the whole shelf, not just the best sellers); collections load side by side
    await Promise.all(sources.map(async ([handle, gender]) => {
      for (let page = 1; page <= MAX_PAGES; page += 1) {
        try {
          const res = await fetch(`/collections/${encodeURIComponent(handle)}?view=rd-quiz&sort_by=best-selling&page=${page}`);
          const data = await res.json();
          const items = Array.isArray(data) ? data : data.items || [];
          add(items, gender);
          if (Array.isArray(data) || !data.more) break;
        } catch (e) { break; }                        // a page that fails to load ends that collection
      }
    }));
    CATALOG = [...byUrl.values()].filter((p) => KEYS.some((k) => p.profile[k] > 0));
    loading = null;
    return CATALOG;
  })()));

  const QUESTIONS = [
    { title: "Pick the scent you’d <em>stop for</em>.", options: [
      { label: "Fresh citrus and sea air", sub: "Clean, bright, effortless", w: { fresh: 3 } },
      { label: "A bouquet of flowers", sub: "Romantic, soft, elegant", w: { floral: 3, fruity: 0.5 } },
      { label: "Vanilla and warm sugar", sub: "Sweet, cosy, addictive", w: { sweet: 3, warm: 1 } },
      { label: "Leather, oud and smoke", sub: "Dark, rich, unforgettable", w: { smoky: 3, woody: 1.5 } },
      { label: "Spice, amber and incense", sub: "Warm, bold, magnetic", w: { spicy: 2.5, warm: 2 } },
    ] },
    { title: "Who’s it <em>for</em>?", options: [
      { label: "Me: I love feminine scents", gender: "her" },
      { label: "Me: I lean masculine", gender: "him" },
      { label: "Me: anything goes", gender: "any" },
      { label: "It’s a gift", sub: "We’ll keep it crowd-pleasing", gender: "any", gift: true },
    ] },
    { title: "Where do you want the <em>compliments</em>?", options: [
      { label: "At work and every day", w: { fresh: 1.5, floral: 1, woody: 0.5 }, strength: -0.5 },
      { label: "On date night", w: { sweet: 1.5, warm: 1.5, spicy: 0.5 } },
      { label: "On a night out", w: { spicy: 1.2, smoky: 1, sweet: 1 }, strength: 0.5 },
      { label: "On weekends and vacations", w: { fresh: 1.5, fruity: 1.5 } },
    ] },
    { title: "Pick a <em>place</em>.", options: [
      { label: "A beach at sunset", w: { fresh: 2, fruity: 0.5 } },
      { label: "A garden in full bloom", w: { floral: 2, fruity: 1 } },
      { label: "A fireplace in winter", w: { warm: 1.5, sweet: 1.5, spicy: 1 } },
      { label: "A leather armchair in an old library", w: { woody: 2, smoky: 1.5 } },
      { label: "A rooftop bar at midnight", w: { spicy: 1.2, sweet: 1, smoky: 1 } },
    ] },
    { title: "How strong should it <em>be</em>?", options: [
      { label: "Close to the skin", sub: "Noticed when someone leans in", strength: -1 },
      { label: "Noticeable, never loud", sub: "A soft trail as you pass", strength: 0 },
      { label: "Leaves a trail", sub: "They’ll ask what you’re wearing", strength: 1 },
    ] },
    { title: "What’s your <em>budget</em>?", options: [
      { label: "Under $60", max: 60 },
      { label: "$60 to $130", min: 60, max: 130 },
      { label: "$130 and up", min: 130 },
      { label: "Whatever it takes" },
    ] },
  ];

  const match = (catalog, answers) => {
    const chosen = answers.map((i, q) => QUESTIONS[q].options[i]);
    const want = Object.fromEntries(KEYS.map((k) => [k, 0]));
    chosen.forEach((o) => Object.entries(o.w || {}).forEach(([k, v]) => (want[k] += v)));
    const len = Math.hypot(...KEYS.map((k) => want[k])) || 1;
    const gender = (chosen.find((o) => o.gender) || {}).gender || "any";
    const strength = Math.max(-1, Math.min(1, chosen.reduce((s, o) => s + (o.strength || 0), 0)));
    const budget = chosen.find((o) => "min" in o || "max" in o) || {};
    const gift = chosen.some((o) => o.gift);
    const scored = catalog.map((p) => {
      const style = KEYS.reduce((s, k) => s + (want[k] / len) * p.profile[k], 0) * 10 * (0.6 + 0.4 * p.profile.sure);
      const g = gender === "any" ? (p.gender === "shared" ? 0.4 : 0) : p.gender === gender ? 2 : p.gender === "shared" ? 1 : -4;
      const st = 1 - Math.abs(strength - p.strength) * 0.7;
      const inBudget = (budget.min == null || p.p >= budget.min) && (budget.max == null || p.p < budget.max);
      const b = budget.min == null && budget.max == null ? 0 : inBudget ? 1.5 : -4;
      const giftBonus = gift && p.strength === 0 ? 0.5 : 0;
      const photo = p.i ? 0 : -2.5;                       // a listing without a photo would show an empty tile
      return { p, score: style + g + st + b + giftBonus + photo };
    }).sort((a, b) => b.score - a.score);
    // Six picks: mostly designer houses (at least 4 when enough match), at most 2 from any one house.
    const SHOW = 6, DESIGNER = 4, PER_HOUSE = 2;
    const houseOf = (p) => (split(p.t)[0] || p.t.split(" ")[0]).toLowerCase();
    // one size per fragrance: "Club De Nuit Intense Man EDP 200 ml" and "... 250 ml" are the same pick
    const scentOf = (p) => p.t.toLowerCase().replace(/\(.*?\)|[\d.,]+\s*(ml|oz|fl\.? ?oz)\b|\/|\b(eau de parfum|eau de toilette|eau de cologne|edp|edt|edc|parfum|extrait|spray|refillable|for (women|men)|unisex)\b/g, " ").replace(/\s+/g, " ").trim();
    const top = [], perHouse = new Map(), scents = new Set();
    const take = (r) => { top.push(r); scents.add(scentOf(r.p)); perHouse.set(houseOf(r.p), (perHouse.get(houseOf(r.p)) || 0) + 1); };
    const room = (r) => !top.includes(r) && !scents.has(scentOf(r.p)) && (perHouse.get(houseOf(r.p)) || 0) < PER_HOUSE;
    const pool = scored.slice(0, 400);
    let designers = 0, others = 0;
    pool.forEach((r) => {
      if (top.length >= SHOW || !room(r)) return;
      if (!r.p.a && designers < DESIGNER) { take(r); designers += 1; }
      else if (r.p.a && others < SHOW - DESIGNER) { take(r); others += 1; }
    });
    pool.forEach((r) => { if (top.length < SHOW && room(r)) take(r); });   // not enough of one kind: fill with the next best
    top.sort((a, b) => b.score - a.score);
    const best = (top[0] && top[0].score) || 1;
    top.forEach((r, i) => (r.pct = Math.max(80, Math.min(98, Math.round(98 - (best - r.score) * 3 - i)))));
    return { top, lead: KEYS.slice().sort((a, b) => want[b] - want[a]).slice(0, 2), gift };
  };

  const el = document.createElement("div");
  el.className = "quiz";
  el.hidden = true;
  el.setAttribute("role", "dialog");
  el.setAttribute("aria-modal", "true");
  el.setAttribute("aria-labelledby", "quiz-title");
  el.innerHTML = `
    <div class="quiz__panel">
      <div class="quiz__bar">
        <button class="quiz__back" type="button" data-quiz-back><span aria-hidden="true">←</span> Back</button>
        <p class="quiz__step" data-quiz-step></p>
        <button class="quiz__close" type="button" data-quiz-close>Close <span aria-hidden="true">✕</span></button>
      </div>
      <div class="quiz__progress" aria-hidden="true"><span data-quiz-progress></span></div>
      <div class="quiz__body" data-quiz-body></div>
    </div>`;
  quizHome.closest(".rd").appendChild(el);
  const body = $("[data-quiz-body]", el);
  const stepEl = $("[data-quiz-step]", el);
  const bar = $("[data-quiz-progress]", el);
  const back = $("[data-quiz-back]", el);
  const shopHref = quizHome.dataset.shop || "/collections/all";
  const lettersHref = quizHome.dataset.letters || "";

  let answers = [], step = 0, opener = null, timer;
  const swap = (html, focusSel) => {
    body.classList.add("is-swapping");
    clearTimeout(timer);
    timer = setTimeout(() => {
      body.innerHTML = html;
      body.classList.remove("is-swapping");
      const f = $(focusSel, body);
      if (f) f.focus({ preventScroll: true });
      el.scrollTop = 0;
    }, body.innerHTML ? 260 : 0);
  };
  const showQuestion = () => {
    const q = QUESTIONS[step];
    stepEl.textContent = `Question ${step + 1} of ${QUESTIONS.length}`;
    bar.style.width = `${(step / QUESTIONS.length) * 100}%`;
    back.style.visibility = step ? "visible" : "hidden";
    swap(`
      <p class="eyebrow">The scent quiz</p>
      <h2 class="display quiz__q" id="quiz-title" tabindex="-1">${q.title}</h2>
      <div class="quiz__options" role="group" aria-labelledby="quiz-title">
        ${q.options.map((o, i) => `
          <button class="quiz__opt" type="button" data-answer="${i}" aria-pressed="${answers[step] === i}">
            <span class="quiz__opt-l">${o.label}</span>${o.sub ? `<span class="quiz__opt-s">${o.sub}</span>` : ""}
          </button>`).join("")}
      </div>`, "#quiz-title");
  };
  const showResults = async () => {
    stepEl.textContent = "Your matches";
    bar.style.width = "100%";
    back.style.visibility = "visible";
    if (!CATALOG) swap(`<p class="eyebrow">Your scent profile</p><p class="quiz__loading">Finding your matches on our shelves…</p>`, "p");
    const catalog = await loadCatalog();
    if (step < QUESTIONS.length) return;                    // they went back while we loaded
    if (!catalog.length) {
      swap(`<p class="eyebrow">Your scent profile</p><h2 class="display quiz__q" id="quiz-title" tabindex="-1">We couldn’t load the shelves</h2>
        <div class="quiz__after"><button class="quiz__again" type="button" data-quiz-again>Try again</button>
        <a class="link-cta" href="${esc(shopHref)}" data-quiz-go>Shop all fragrances <span class="arrow" aria-hidden="true">→</span></a></div>`, "#quiz-title");
      return;
    }
    const { top, lead, gift } = match(catalog, answers);
    const why = (r) => {
      const styles = KEYS.slice().sort((a, b) => r.p.profile[b] - r.p.profile[a]).slice(0, 2).map((k) => NAMES[k].toLowerCase());
      const notes = r.p.notes.slice(0, 3).map((n) => n.toLowerCase());
      const s0 = styles[0].charAt(0).toUpperCase() + styles[0].slice(1);
      return `${s0} and ${styles[1]}${notes.length ? `: ${notes.join(", ")}` : ""}.`;
    };
    swap(`
      <p class="eyebrow">Your scent profile</p>
      <h2 class="display quiz__q" id="quiz-title" tabindex="-1">${NAMES[lead[0]]} &amp; ${NAMES[lead[1]].toLowerCase()}</h2>
      <p class="quiz__lede">${PROFILE_LINE[lead[0]]}${gift ? " We kept it easy to love, so it makes a safe, generous gift." : ""}</p>
      <ol class="quiz__results">
        ${top.map((r, i) => {
          const [house, name] = split(r.p.t);
          return `<li class="quiz__result">
            <a href="${esc(r.p.u)}" data-quiz-go>
              <span class="quiz__media">${r.p.i ? `<img src="${esc(r.p.i)}" alt="" loading="lazy">` : ""}</span>
              <span class="quiz__match">${i === 0 ? "Best match · " : ""}${r.pct}% match</span>
              <span class="quiz__brand">${esc(house)}</span>
              <span class="quiz__name">${esc(name)}</span>
              <span class="quiz__why">${esc(why(r))}</span>
              <span class="quiz__price">${money(r.p.p)}</span>
              <span class="quiz__view">View fragrance <span aria-hidden="true">→</span></span>
            </a>
          </li>`;
        }).join("")}
      </ol>
      <div class="quiz__after">
        <button class="quiz__again" type="button" data-quiz-again>Retake the quiz</button>
        <a class="link-cta" href="${esc(shopHref)}" data-quiz-go>Shop all fragrances <span class="arrow" aria-hidden="true">→</span></a>
        ${lettersHref ? `<a class="quiz__offer" href="${esc(lettersHref)}" data-quiz-go>New here? Join our letters for new arrivals and private offers.</a>` : ""}
      </div>`, "#quiz-title");
  };
  const render = () => (step < QUESTIONS.length ? showQuestion() : showResults());

  const open = (first) => {
    opener = document.activeElement;
    answers = [];
    step = 0;
    body.innerHTML = "";
    if (first != null) { answers[0] = first; step = 1; }
    el.hidden = false;
    document.body.style.overflow = "hidden";
    void el.offsetWidth;
    el.classList.add("is-open");
    render();
    loadCatalog();                                           // start fetching while they answer
  };
  const close = () => {
    el.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(() => { el.hidden = true; }, 400);
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  };

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-quiz-open]");
    if (!trigger) return;
    e.preventDefault();
    const first = trigger.dataset.quizFirst;
    open(first == null ? null : Number(first));
  });
  el.addEventListener("click", (e) => {
    const opt = e.target.closest("[data-answer]");
    if (opt) {
      answers[step] = Number(opt.dataset.answer);
      $$("[data-answer]", body).forEach((b) => b.setAttribute("aria-pressed", String(b === opt)));
      step += 1;
      setTimeout(render, 220);
      return;
    }
    if (e.target.closest("[data-quiz-back]")) { step = Math.max(0, step - 1); render(); return; }
    if (e.target.closest("[data-quiz-again]")) { answers = []; step = 0; render(); return; }
    if (e.target.closest("[data-quiz-close]")) { close(); return; }
    if (e.target.closest("[data-quiz-go]")) close();
  });
  document.addEventListener("keydown", (e) => {
    if (el.hidden) return;
    if (e.key === "Escape") { close(); return; }
    if (e.key === "Tab") {
      const items = $$("button, a[href], [tabindex='-1']", el).filter((n) => n.offsetParent !== null && n.style.visibility !== "hidden");
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  if (location.hash === "#quiz") open(null);
})();
